import React, { useState, useEffect } from "react";
import { Typography, Paper, Grid, IconButton, LinearProgress, GridSize } from "@material-ui/core";
import ZoomOutMapIcon from "@material-ui/icons/ZoomOutMap";
import ImagePopupWindow from "./ImagePopupWindow";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(({
    imageItem: {
        textAlign: "center", 
    },
    imgNameText : {
        paddingTop: 10,
        marginBottom: 10
    },
    imgNoteText: {
        paddingBottom: 10
    },
    imgContainer: {
        position: "relative"
    },
    imgHidden: {
        display: "none"
    },
    imgVisible: {
        display: "block"
    },
    progressBar: {
        "& .MuiLinearProgress-barColorPrimary": {
            backgroundColor: "#3474b4"
        }
    },
    iconButton: {
        position: "absolute",
        top: -10,
        right: 0,
        color: "white"
    }
}));

type ImageViewerItemProps = {
    imgName: string,
    imgUrl: string,
    imgStyle: { style: {}, itemXs: GridSize },
    imgNote?: string
}

/**
 * The Component is used to show each images item of capture and provide the function to open dialog to check full resolution image
 */
const ImageViewerItem: React.FunctionComponent<ImageViewerItemProps> = (props: ImageViewerItemProps) => {
    const styles = useStyles();
    const [openDialog, setOpenDialog] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        setImageLoaded(false);
    }, [props.imgUrl]);

    const handleImageLoad = () => {
        setImageLoaded(true);
    }

    const handleClickOpen = () => {
        setOpenDialog(true);
    }

    const handleClose = () => {
        setOpenDialog(false);
    }

    const imageStyle = makeStyles({
        image: props.imgStyle.style
    });

    let imageNote;
    if (props.imgNote) {
        imageNote = (
            <Grid item xs={12}>
                <Typography
                    className={styles.imgNoteText}
                    component='p'>
                    {props.imgNote}
                </Typography>
            </Grid>
        )
    }

    return(  
        <Grid className={styles.imageItem} item xs={props.imgStyle.itemXs}>
            <Paper elevation={2}>
                <Grid item xs={12}>
                    <Typography
                        className={styles.imgNameText}
                        component='p'>
                        {props.imgName.toUpperCase()}
                    </Typography>
                </Grid>
                <Grid className={styles.imgContainer} item xs={12}> 
                    {imageLoaded ? <div></div> : <LinearProgress className={styles.progressBar}/>}
                    <div className={imageLoaded ? styles.imgVisible : styles.imgHidden}>
                        <img
                            className={imageStyle().image}
                            src={props.imgUrl}
                            alt={props.imgName}
                            onLoad={handleImageLoad}/>
                        <IconButton className={styles.iconButton} onClick={handleClickOpen} >
                            <ZoomOutMapIcon />
                        </IconButton>
                        <ImagePopupWindow open={openDialog} onCloseDialog={handleClose} imgName={props.imgName} imgUrl={props.imgUrl} imgNote={props.imgNote}/>
                    </div>
                </Grid>
                {imageNote}
            </Paper>
        </Grid>    
    );
}

export default ImageViewerItem;